import { ReactComponent as Hostel } from "../../assets/svgs/hostelImg.svg";
import { ReactComponent as BedSpace } from "../../assets/svgs/bed-space.svg";
import { Badge } from "../badge/badge";
import { Button } from "../button/Button";
import "./FloorCard.css";

export const FloorCard = ({
	floorName,
	numberOfRooms,
	numberOfBeds,
	numberOfBedsAvailable,
	disabled = false,
	onClick
}) => {
	const hasBedStats =
		numberOfBeds !== null &&
		numberOfBeds !== undefined &&
		numberOfBedsAvailable !== null &&
		numberOfBedsAvailable !== undefined;
	const availabilityRatio = numberOfBeds
		? numberOfBedsAvailable / numberOfBeds
		: 0;
	const availabilityType =
		numberOfBedsAvailable === 0
			? "pending"
			: availabilityRatio < 0.5
			? "unapproved"
			: "success";

	return (
		<div className={`floor-card ${disabled ? "floor-card--disabled" : ""}`}>
			<Hostel />
			<div className="floor-card__details">
				<h5>{floorName}</h5>
				<div className="floor-card__stats">
					<p>
						{numberOfRooms || 0}
						<span>rooms</span>
					</p>
					{hasBedStats && (
						<>
							<span className="floor-card__divider">|</span>
							<div className="floor-card__beds">
								<BedSpace />
								<p>{numberOfBeds}</p>
								<Badge
									item={{
										title: `${numberOfBedsAvailable} Left`,
										type: availabilityType
									}}
								/>
							</div>
						</>
					)}
					{disabled && (
						<>
							<span className="floor-card__divider">|</span>
							<Badge item={{ title: "Unavailable", type: "unapproved" }} />
						</>
					)}
				</div>
			</div>
			<Button
				label="View"
				buttonClass="primary"
				disabled={disabled}
				onClick={onClick}
			/>
		</div>
	);
};
